import { useContext } from 'react'
import { useSelector } from 'react-redux'

import { Button } from 'core/components'

import { AuthContext } from 'providers/auth'

import { TRootReducer } from 'store'

import {
  OrgsContainer,
  OrgsHeader,
  OrgsWrapper,
  OrgCard,
  OrgCardBrand,
  OrgCardTitle,
} from './styles'

function OrgsView() {
  const { app } = useSelector((state: TRootReducer) => state)
  const { signOut } = useContext(AuthContext)

  return (
    <OrgsContainer>
      <OrgsHeader>
        <h2>Empresas</h2>
        <span>
          Lista de empresas que você já pontou, clique para verificar se há
          saldo, visualizar histórico de pontos e recompensas.
        </span>
      </OrgsHeader>

      <OrgsWrapper>
        {!app.orgs.length ? (
          <span style={{ display: 'block', textAlign: 'center' }}>
            Nenhuma empresa disponível
          </span>
        ) : (
          app.orgs.map(org => (
            <OrgCard to={`/${org.key}`} key={org.key} replace>
              <OrgCardBrand src={org.brand} alt={org.name} />
              <OrgCardTitle>{org.name}</OrgCardTitle>
            </OrgCard>
          ))
        )}
      </OrgsWrapper>

      <Button color="primary" onClick={() => signOut()}>
        Acessar outra Conta
      </Button>
    </OrgsContainer>
  )
}

export { OrgsView }
